<template>
  <div class="container">
    <div class="cookie__message">
      <z-title
        size="medium"
        tag="h1"
      >
        Política de Cookies
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Atualizada em 05 de agosto de 2021
      </z-text>

      <z-text
        tag="p"
        align="left"
      >
        Nosso site usa cookies para melhorar o desempenho e aprimorar a sua experiência de navegação. Certas áreas do
        nosso site também utilizam cookies para entender mais sobre você, para que possamos oferecer uma experiência
        de navegação mais personalizada. Ao continuar a usar este website, você toma conhecimento de que nós
        poderemos instalar cookies ou outras tecnologias similares em seu equipamento, inclusive dispositivo móvel.
      </z-text>

      <z-title
        tag="h2"
        size="nano"
      >
        O que são cookies?
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Cookies são pequenos arquivos, contendo algumas poucas informações sobre seu acesso, e que são
        baixados para seu dispositivo quando você visita um site. Estes arquivos permitem ao site reconhecer
        o seu equipamento e registrar sua interação nas páginas do próprio site. O termo "cookie" pode ser
        usado para descrever uma série de tecnologias, incluindo, mas não se limitando a pixel tags, web beacons
        e identificadores de dispositivo móvel.
      </z-text>

      <z-title
        tag="h2"
        size="nano"
      >
        Por que usamos cookies?
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Os cookies exercem muitas tarefas diferentes, como otimizar sua navegação pelas páginas, lembrar suas
        preferências, e personalizar sua experiência durante a navegação. Eles ainda ajudam a garantir que os
        anúncios e outros conteúdos que você acessar online são relevantes para você. Além disso, são utilizados
        para coletar dados estatísticos.
      </z-text>

      <z-title
        tag="h2"
        size="nano"
      >
        Como os Cookies são utilizados pela <span class="cookies-policy__uppercase">Quero Educação</span>?
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        A <strong>Quero</strong> Educação utiliza os seguintes tipos de Cookies:
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        <strong>Cookies Essenciais</strong> - Os cookies essenciais são necessários para o funcionamento dos
        Sites e prestação dos serviços a você. Sem estes cookies, os Sites não funcionarão tão bem como nós
        gostaríamos e podemos não ser capazes de fornecer determinados serviços ou recursos a eles associados.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        <strong>Cookies</strong> de Preferências - Os cookies de preferências coletam informações sobre suas
        escolhas e preferências, permitindo que os nossos Sites se lembrem do idioma, localização, dispositivo
        utilizado ou outras configurações e que a sua experiência seja personalizada de acordo com essas preferências.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        <strong>Cookies Analíticos/Estatísticos</strong> - Os cookies analíticos coletam informações sobre a
        utilização dos Sites, permitindo-nos aperfeiçoar o seu funcionamento. Os cookies analíticos, por exemplo,
        mostram-nos quais são as páginas mais visitadas nos Sites, ajudam-nos a registar quaisquer dificuldades
        que os usuários sintam na navegação nos Sites, e mostram-nos se a nossa publicidade é eficaz ou não.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        <strong>Cookies de Publicidade/Marketing</strong> - Os cookies de publicidade são utilizados para fins
        de marketing, permitindo o direcionamento dos anúncios que aparecem para você com base nos seus interesses.
        O objetivo é tornar o conteúdo publicitário mais relevante para você, melhorar os relatórios sobre o
        desempenho da campanha e evitar a exibição de anúncios que você já viu.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        Dentro destas quatro categorias, os cookies podem ser classificados como cookies “de sessão” ou “persistentes”.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        Cookies “de sessão” são temporários e, uma vez que você fechar a janela do navegador, eles serão excluídos
        de seu dispositivo.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        Os cookies “persistentes” permanecem no seu dispositivo até sua data de expiração e são usados pelo site
        para reconhecer seu dispositivo quando você voltar.
      </z-text>

      <z-title
        tag="h2"
        size="nano"
      >
        Vocês usam cookies de terceiros?
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Alguns cookies que usamos são de outras empresas, como Google Analytics, para nos prover inteligência
        analítica sobre nossos sites. Estas companhias usam códigos de programação para coletar informações
        sobre sua interação com nossos sites, como as páginas que você visita, os links nos quais você clica e
        por quanto tempo você permanece conectado em nossos sites. Este código fica ativo somente enquanto você
        estiver no site da Quero Educação.
      </z-text>

      <z-title
        tag="h2"
        size="nano"
      >
        Que outras tecnologias de rastreamento utilizamos?
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Podemos também usar web beacons (inclusive pixels de conversão) ou outras tecnologias para fins semelhantes,
        e podemos incluí-los em nossos sites, em mensagens de e-mail de marketing ou em nossos boletins informativos
        e websites de afiliadas, para determinar se as mensagens foram abertas e se os links foram clicados. Os web
        beacons não instalam informações em seu dispositivo, mas podem trabalhar em conjunto com os cookies para
        monitorar a atividade do site. Pixels de conversão são pequenos códigos localizados numa página web em
        particular que são alterados quando alguém visita a página, resultando num aumento da contagem de conversão.
      </z-text>

      <z-title
        tag="h2"
        size="nano"
      >
        E se eu não quiser os cookies?
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Ao utilizar nosso site, você concorda que nós podemos instalar cookies em seu dispositivo, conforme
        explicado abaixo. No seu primeiro acesso, surgirá um “banner de cookies” informando sobre a utilização
        de cookies em nosso site. Caso você queira remover os cookies existentes em seu dispositivo, você
        conseguirá fazê-lo usando as opções do navegador. Caso você queira bloquear cookies futuros em seu
        dispositivo, você poderá alterar a configuração do navegador para fazê-lo.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        Por favor, tenha em mente que a exclusão e o bloqueio de cookies terão impacto em sua experiência de
        usuário, pois partes do site podem não funcionar corretamente. A menos que você tenha ajustado a
        configuração do navegador para bloquear os cookies, nosso sistema emitirá cookies quando você visitar
        nosso site ou clicar em um link de um e-mail que enviarmos a você, mesmo se você já tiver excluído
        nossos cookies.
      </z-text>
      <z-text
        tag="p"
        align="left"
      >
        Caso tenha alguma pergunta acerca desta Política de Cookies, por favor contate-nos por meio do e-mail:
        <z-link href="mailto:privacidade@quero.com">
          privacidade@quero.com
        </z-link>.
      </z-text>
    </div>
  </div>
</template>

<script>
import { ZText, ZLink, ZTitle } from '@quero/zilla-vue';

export default {
  components: {
    ZText,
    ZLink,
    ZTitle,
  },
};
</script>

<style lang="scss" scoped>
.cookie__message {
  padding: var(--size-jumbo) 0;
  & .z-title,
  & .z-text {
    padding: var(--size-small) 0;
  }
}
.cookies-policy__uppercase {
  text-transform: uppercase;
}
.cookies-policy__list-item {
  font-weight: bold;
}
.cookies-policy__inline-block {
  display: inline-block;
}
</style>
